import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ViewStreamIcon(props: IconProps) {
    return <Icon {...props} iconKey={"view_stream"}/>
}
